import { render, staticRenderFns } from "./NewTemplatePage.vue?vue&type=template&id=369b8663&scoped=true"
import script from "./NewTemplatePage.vue?vue&type=script&lang=js"
export * from "./NewTemplatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b8663",
  null
  
)

export default component.exports